import { useSearchParams } from 'hooks/useSearchParams';

const salaryStructureDetailsViewParamKey = 'structureId';

export const useSalaryStructureDetailsView = () => {
  const { addSearchParams, removeSearchParams, urlParams } = useSearchParams();

  const structureId = urlParams.get(salaryStructureDetailsViewParamKey);

  const openDetailsView = (id: string) => {
    addSearchParams([{ key: salaryStructureDetailsViewParamKey, value: id }]);
  };

  const closeDetailsView = () => {
    removeSearchParams([salaryStructureDetailsViewParamKey]);
  };

  return {
    structureId,
    openDetailsView,
    closeDetailsView,
    isDetailsViewOpen: !!structureId,
  };
};

